module.exports = __webpack_public_path__ + "static/media/transparent-info.a952ecf1.svg";